module.exports = __webpack_public_path__ + "static/media/full_logo.d9ed1be5.svg";